import React from 'react'

import { Form, Col } from '_zari/core'

const RazonSocialFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='RAZON SOCIAL' htmlFor='input-razonSocial' md={4} />
      <Col md={8}>
        <Form.InputText id='input-razonSocial' name='input-razonSocial' placeholder={value} disabled />
      </Col>
    </Form.Group>
  )
}

export default RazonSocialFormGroup
